import {
  SET_MAIN_DATA,
  CHANGE_MAIN_DATA,
  BLUR_MAIN_DATA,
  LOAD_DRAFT_EMPTY
} from '../constants';

const initialState = {
  data: {},
  editableFields: {},
  blur: {},
  firstState: null
};

const mainData = (state = initialState, action) => {
  switch (action.type) {
    case SET_MAIN_DATA:
      return {
        ...state,
        ...action.payload,
        firstState: { ...action.payload },
        blur: {}
      };
    case BLUR_MAIN_DATA:
      return {
        ...state,
        blur: {
          ...state.blur,
          [action.payload]: true
        }
      };
    case CHANGE_MAIN_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.data
        },
        blur: {
          ...state.blur,
          [action.payload.field]: false
        }
      };
    case LOAD_DRAFT_EMPTY:
      return {
        ...initialState,
        ...state.firstState,
        firstState: { ...state.firstState }
      };
    default:
      return state;
  }
};

export default mainData;
